"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = exports.Carousel = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Wrapper = styled_components_1.default.div `
  width: 100%;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  flex-direction: column;
`;
exports.Carousel = styled_components_1.default.div `
  ${({ theme, hasScrolling, space, lightMode }) => `
    width: 100%;
    overflow-x: scroll;
    display: flex;
    padding: ${theme.spaces.sp1} 0 ${theme.spaces.sp5} ${theme.spaces.sp5};

    z-index: 1;

    ::-webkit-scrollbar {
      height: 4px;
      ${hasScrolling ? '' : 'display: none;'}
    }

    ::-webkit-scrollbar-track {
      background: ${lightMode
    ? theme.colors.action.navigation.alt.disabled
    : theme.colors.action.navigation.standard.disabled};
      border-radius: 40px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${lightMode
    ? theme.colors.action.navigation.alt.static
    : theme.colors.action.navigation.standard.static};
      border-radius: 40px;
    }
    ::-webkit-scrollbar-button:end:increment {
      width: 176px;
      display: block;
      background: transparent;
    }
    ::-webkit-scrollbar-button:start:increment {
      width: ${theme.spaces.sp5};
      display: block;
      background: transparent;
    }

    > div {
      margin-right:${space || theme.spaces.sp2};
    }
    > div:last-child {
      min-width: 1px;
      height: 1px;
    }
  `}
`;
exports.Footer = styled_components_1.default.div `
  ${({ theme }) => `
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 ${theme.spaces.sp5};
  `}
`;
